module.exports = __webpack_public_path__ + "static/media/wall-2.25d80fbc.jpg";